



// import React from "react";
// import css from "../Modulecss/Home.module.css";

// // Utility function to get the first name or a truncated version
// // Note: This utility is adapted for the BotTable structure using running.name1 and running.name2
// const getPlayerDisplayName = (name) => {
//     if (!name) return 'Unknown';
//     const parts = name.split(' ');
//     return parts[0] || name.substring(0, 10);
// };

// export default function BotTable({ running, winnAmount }) {
//     const imageBase = "https://api.rrludo.in/";
//     const gameAmount = running.amount;
//     const prizeAmount = gameAmount + winnAmount(gameAmount);

//     return (
//         <>
//             <style>
//                 {`
//                     /* Styles to ensure compactness and the desired look */
//                     .running-card-compact {
//                         background: linear-gradient(145deg, #ffffff, #f9f9f9);
//                         border: 2px solid #a8c0ff; /* Light border */
//                         border-radius: 10px;
//                         box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
//                         padding: 8px 10px; /* Reduced padding */
//                         font-family: Arial, sans-serif;
//                     }

//                     .player-name-compact {
//                         font-size: 11px;
//                         font-weight: 700;
//                         color: #333;
//                         text-overflow: ellipsis;
//                         white-space: nowrap;
//                         overflow: hidden;
//                         max-width: 60px; 
//                         margin-top: 4px;
//                         text-align: center;
//                     }
                    
//                     .amount-text {
//                         font-weight: 800;
//                         font-size: 14px;
//                     }

//                     .vs-logo {
//                         font-size: 18px;
//                         font-weight: 900;
//                         color: #FF4500; /* Red/Orange for VS */
//                         margin: 0 5px;
//                         text-shadow: 0 0 2px rgba(0,0,0,0.1);
//                     }
//                 `}
//             </style>

//             {/* Apply the compact card style */}
//             <div className="mx-2 mb-2 running-card-compact">
//                 {/* Top Bar: Playing For | Prize (Aligned Left/Right) */}
//                 <div className="d-flex align-items-center justify-content-between mb-3" 
//                      style={{ paddingBottom: '5px', borderBottom: '1px solid #f0f0f0' }}
//                 >
                    
//                     {/* Playing For / Entry Fee (Left Aligned) */}
//                     <div className="d-flex align-items-center">
//                         <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '4px' }}>
//                             Playing For
//                         </span>
//                         <img
//                             src={process.env.PUBLIC_URL + "/images/LandingPage_img/global-rupeeIcon.png"}
//                             alt="coin"
//                             width="15px"
//                             className="mr-1"
//                         />
//                         <span className="amount-text" style={{ color: '#000' }}>
//                             {gameAmount}
//                         </span>
//                     </div>

//                     {/* Prize (Right Aligned) */}
//                     <div className="d-flex align-items-center">
//                         <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '4px' }}>
//                             Prize
//                         </span>
//                         <img
//                             src="/images/LandingPage_img/global-rupeeIcon.png"
//                             alt="prize"
//                             width="15px"
//                             className="mr-1"
//                         />
//                         <span className="amount-text" style={{ color: '#000' }}>
//                             {prizeAmount}
//                         </span>
//                     </div>
//                 </div>
                
//                 {/* Main Content: Player 1 (Left) VS (Center) Player 2 (Right) */}
//                 <div className="d-flex align-items-center justify-content-between">
                    
//                     {/* Player 1 (name1) - Left Side */}
//                     <div className="d-flex flex-column align-items-center" style={{ width: '30%' }}>
//                         <img
//                             src={`${imageBase}${running.avatar}`}
//                             alt="Player 1 Avatar"
//                             width="40px" 
//                             height="40px"
//                             style={{
//                                 borderRadius: '50%',
//                                 border: '2px solid #FF4500', // Distinct border for player 1
//                             }}
//                             onError={(e) => (e.target.src = "/images/avatars/Avatar2.png")} // Fallback
//                         />
//                         <div className="player-name-compact mx-auto">
//                             {getPlayerDisplayName(running.name1)}
//                         </div>
//                     </div>

//                     {/* VS Divider - Center */}
//                     <div className="text-center" style={{ width: '20%' }}>
//                         <span className="vs-logo">
//               <img src='/images/Homepage/versus.png' className='img-fluid vs_img' />
                            
//                         </span>
//                     </div>

//                     {/* Player 2 (name2) - Right Side */}
//                     <div className="d-flex flex-column align-items-center" style={{ width: '30%' }}>
//                         <img
//                             src={`${imageBase}${running.avatar}`}
//                             alt="Player 2 Avatar"
//                             width="40px"
//                             height="40px"
//                             style={{
//                                 borderRadius: '50%',
//                                 border: '2px solid #0000FF', // Distinct border for player 2
//                             }}
//                             onError={(e) => (e.target.src = "/images/avatars/Avatar3.png")} // Fallback
//                         />
//                         <div className="player-name-compact mx-auto">
//                             {getPlayerDisplayName(running.name2)}
//                         </div>
//                     </div>

//                     {/* Placeholder for Action (VIEW Button equivalent) - Optional for BotTable */}
//                     {/* Since this is a BotTable, there is no explicit VIEW button link in the original code,
//                         so we can leave this space empty or add a status label. */}
                  
//                 </div>
//             </div>
//         </>
//     );
// }


import React from "react";

const getPlayerDisplayName = (name) => {
    if (!name) return 'Unknown';
    const parts = name.split(' ');
    return parts[0] || name.substring(0, 10);
};

export default function BotTable({ running, winnAmount }) {
    const imageBase = "https://api.rrludo.in/";
    const gameAmount = running.amount;
    const prizeAmount = gameAmount + winnAmount(gameAmount);

    return (
        <div
            className="mx-2 mb-2"
            style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                border: '1px solid #d1d1d1',
                overflow: 'hidden',
                fontFamily: 'sans-serif',
            }}
        >
            {/* Header Section - Matches BetCard Purple Title */}
            <div 
                className="px-3 py-1 d-flex justify-content-between align-items-center" 
                style={{ borderBottom: '1px solid #e0e0e0' }}
            >
                <span style={{ color: '#ec9728', fontWeight: '600', fontSize: '14px' }}>
                    Live Game
                </span>
                <span style={{ fontSize: '10px', color: '#999', fontWeight: 'bold' }}>LIVE</span>
            </div>

            {/* Body Section - Matches BetCard Light Grey Body */}
            <div 
                className="px-3 py-2" 
                style={{ backgroundColor: '#f9f9f9' }}
            >
                {/* Top Row: Amounts (Tighter Spacing for minimal height) */}
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className="d-flex align-items-center">
                        <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '5px' }}>
                            Playing For
                        </span>
                        <img 
                            src="/images/LandingPage_img/global-rupeeIcon.png" 
                            alt="coin" 
                            width="16px" 
                        />
                        <span style={{ fontSize: '15px', fontWeight: 'bold', marginLeft: '3px', color: '#000' }}>
                            {gameAmount}
                        </span>
                    </div>
                    <div className="d-flex align-items-center">
                        <span style={{ fontSize: '11px', color: '#555', fontWeight: '600', marginRight: '5px' }}>
                            Prize
                        </span>
                        <img 
                            src="/images/LandingPage_img/global-rupeeIcon.png" 
                            alt="prize" 
                            width="16px" 
                        />
                        <span style={{ fontSize: '15px', fontWeight: 'bold', marginLeft: '3px', color: '#000' }}>
                            {prizeAmount}
                        </span>
                    </div>
                </div>

                {/* Main Content Row: Player 1 VS Player 2 */}
                <div className="d-flex align-items-center justify-content-between mt-1">
                    {/* Player 1 */}
                    <div className="d-flex align-items-center" style={{ width: '40%' }}>
                        <img
                            src={`${imageBase}${running.avatar}`}
                            alt="P1"
                            style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                border: '1.5px solid #FF4500',
                            }}
                            onError={(e) => (e.target.src = "/images/avatars/Avatar2.png")}
                        />
                        <div style={{ 
                            fontSize: '12px', 
                            fontWeight: '700', 
                            marginLeft: '6px', 
                            color: '#333', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            whiteSpace: 'nowrap' 
                        }}>
                            {getPlayerDisplayName(running.name1)}
                        </div>
                    </div>

                    {/* VS Divider */}
                    <div className="text-center" style={{ width: '20%' }}>
                        <img 
                            src='/images/Homepage/versus.png' 
                            style={{ width: '20px' }} 
                            alt="vs"
                        />
                    </div>

                    {/* Player 2 */}
                    <div className="d-flex align-items-center justify-content-end" style={{ width: '40%' }}>
                        <div style={{ 
                            fontSize: '12px', 
                            fontWeight: '700', 
                            marginRight: '6px', 
                            color: '#333', 
                            textAlign: 'right', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            whiteSpace: 'nowrap' 
                        }}>
                            {getPlayerDisplayName(running.name2)}
                        </div>
                        <img
                            src={`${imageBase}${running.avatar}`}
                            alt="P2"
                            style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                border: '1.5px solid #0000FF',
                            }}
                            onError={(e) => (e.target.src = "/images/avatars/Avatar3.png")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}